import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "/constants/vp-sizes";
import { BACKGROUND_GRAY_COLOR_NAME, BRAND_BLACK_BACKGROUND_COLOR, BRAND_BLACK_TEXT_COLOR, WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "/styles/colors";
import styled from "@emotion/styled";
export const StyledWhatsNewAppsSection = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;
  padding-left: 2vw;

  .subtle-line {
    border: 0;
    border-top: 1px solid;
    border-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
    margin: 40px 0;
  }

  .title-wrapper {
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;

    .core-title-container .core-title {
      font-size: 1.5rem;
      font-weight: 300;
    }
  }

  .tabs-wrapper {
    .use-cases-tabs-component {
      align-items: baseline;

      .use-cases-tabs-navigation {
        .use-cases-tab-nav-button-wrapper {
          border-color: ${BRAND_BLACK_BACKGROUND_COLOR};

          &:hover {
            border-color: ${BRAND_BLACK_BACKGROUND_COLOR};
            color: ${BRAND_BLACK_TEXT_COLOR};
            background-color: transparent;
          }

          &.selected {
            background-color: ${BRAND_BLACK_BACKGROUND_COLOR};

            &:hover {
              border-color: ${BRAND_BLACK_BACKGROUND_COLOR};
              color: ${WHITE_COLOR_NAME};
              background-color: ${BRAND_BLACK_BACKGROUND_COLOR};
            }
          }
        }
      }

      .carousel-wrapper {
        width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
        padding-left: 1vw;
        @media (max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px) {
          padding-left: 0;
        }
      }

      .use-case-tab-content {
        padding-left: 0;
        height: 120px;

        .app-section {
          max-height: 200px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;

          a {
            all: unset;
          }

          .app {
            display: flex;
            flex-direction: row;
            gap: 20px;
            margin-bottom: 30px;
            cursor: pointer;

            .app-image-wrapper {
              width: 60px;

              .asset-inner .picture-component img {
                border-radius: 12px;
              }
            }

            .text-wrapper {
              display: flex;
              flex-direction: column;
              text-align: left;
              justify-content: center;

              .app-title {
                font-size: 0.875rem;
                font-weight: 700;
                line-height: 21px;
              }

              .app-description {
                font-size: 0.875rem;
                font-weight: 300;
                line-height: 21px;
                width: 260px;
              }
            }
          }
        }
      }
    }
  }
`;
